export default defineAppConfig({
  salesForceLayer: {
    debug: false,
    sandbox: false,
  },
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    salesForceLayer?: {
      /**
       * Enable debug mode for Salesforce forms. This will output debug information when submitting a form and mails te status to debugEmail.
       * debugEmail can be set in the playgrounds .env file (see readme).
       * @default false
       */
      debug?: boolean;
      /**
       * Enable sandbox mode for Salesforce forms. This will use the sandbox URL and organisation ID for form submission.
       * @default false
       */
      sandbox?: boolean;
    };
  }
}
